import request from '@/utils/request'

let ajax = {}


/**
 * 获取饲喂器列表
 * 请求类型 post
 * @return code 200->成功
 */
ajax.feeder = (obj) => {
  return request.post(`/api/v1/feeder/pageQry?pageNum=${obj.pageNum}&pageSize=${obj.pageSize}`, obj.bsBarDto)
}

/**
 * 删除饲喂器
 * 请求类型 get
 * @return code 200->成功
 */
ajax.del = (obj) => {
  return request.get(`/api/v1/feeder/del/${obj}`)
}

/**
 * 新增饲喂器
 * 请求类型 post
 * @return code 200->成功
 */
ajax.Save = (obj) => {
  return request.post(`/api/v1/feeder/save`, obj)
}

/**
 * 修改饲喂器
 * 请求类型 post
 * @return code 200->成功
 */
ajax.update = (obj) => {
  return request.post(`/api/v1/feeder/update`, obj)
}

/**
 * 获取饲喂器实时数据
 * 请求类型 post
 * @return code 200->成功
 */
ajax.mqtt = (obj) => {
  return request.post(`/mqtt/pageQryRealtime?pageNum=${obj.pageNum}&pageSize=${obj.pageSize}`, obj.bsBarDto)
}

/**
* 获取饲喂器日志
* 请求类型 post
* @return code 200->成功
*/
ajax.pageQryMqttLog = (obj) => {
  return request.post(`/mqtt/pageQryMqttLog?pageNum=${obj.pageNum}&pageSize=${obj.pageSize}`, obj.bsBarDto)
}

/**
* 获取饲喂器错误日志
* 请求类型 post
* @return code 200->成功
*/
ajax.pageQryMqttErrorLog = (obj) => {
  return request.post(`/mqtt/pageQryMqttErrorLog?pageNum=${obj.pageNum}&pageSize=${obj.pageSize}`, obj.bsBarDto)
}
/**
* 获取系统操作日志
* 请求类型 post
* @return code 200->成功
*/
ajax.pageQrySysLog = (obj) => {
  return request.post(`/mqtt/pageQrySysLog?pageNum=${obj.pageNum}&pageSize=${obj.pageSize}`, obj.bsBarDto)
}

/**
* 清空mongo日志数据
* 请求类型 get
* @return code 200->成功
*/
ajax.drop = (obj) => {
  return request.get(`/mqtt/drop/${obj}`)
}

export default ajax



// WEBPACK FOOTER //
// ./src/api/feeding.js